module.exports = __webpack_public_path__ + "img/tr.c06fedf7.jpg";